/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import {postCancelSensorCheck} from '@/api/concentratorApi';
import {Get} from '@/api/request';
import * as APPDATA from '@/constants/pcConstAppData';
import {eventBusObject} from '@/observers/eventBus';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
}))
class DeviceElementAvailability extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this._bus = eventBusObject();
    this._deviceElementCheckList = [];
    // eslint-disable-next-line no-unused-expressions
    this._deviceElementAvailabiltyRequest;
    // eslint-disable-next-line no-unused-expressions
    this._finishAction;
    this.successGetElementAvailability = this.successGetElementAvailability.bind(this);
  }

  componentDidMount() {
    this.eventDeviceElementAvaialability = this._bus.subscribe(
      DeviceElementAvailabilityEvent.ELEMENT_AVAILABILITY,
      (param) => this.deviceElementAvailabilityCheck(param),
    );
  }

  componentWillUnmount() {
    this.eventDeviceElementAvaialability.unsubscribe();
  }

  deviceElementAvailabilityCheck = () => {
    this._deviceElementCheckList = this.generateTubeELementListCheck();

    const currentElement = undefined;
    this.requestCheckOrder(currentElement);
  };

  requestDeviceElement = (elementCheckType, isPoolingRequest) => {
    if (!isPoolingRequest) {
      const deviceElementCheck = {
        showLoading: true,
        loadingText: APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.CHECK_SYSTEM,
        loadingButton1: {
          id: APPDATA.CANCEL,
          label: APPDATA.CANCEL,
          onClick: this.cancelElementAvailability,
        },
      };
      this.updateMessageLoading(deviceElementCheck);
    }

    const param = {};
    const passingParam = {
      DeviceCheck: elementCheckType,
      IsPoolingRequest: isPoolingRequest,
    };

    let requestTiming = 0;
    if (isPoolingRequest) {
      requestTiming = 500;
    } else {
      requestTiming = 1000;
    }
    clearInterval(this._deviceElementAvailabiltyRequest);
    this._deviceElementAvailabiltyRequest = setTimeout(() => {
      Get(APPDATA.API.DEVICE_ELEMENT_AVAILABILITY, param, this.successGetElementAvailability, passingParam);
    }, requestTiming);
  };

  successGetElementAvailability = (response, passingParam) => {
    let loadingText;
    let loadingButton1;
    let loadingButton2;
    switch (passingParam.DeviceCheck) {
      // 2
      case DeviceElementCheck.WasteBottle: {
        const isWasteBottleAvailable = response.data.WasteBottleSensor;
        if (isWasteBottleAvailable === true) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.WASTE_BOTTLE.DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          loadingButton2 = undefined;
          this.requestCheckOrder(DeviceElementCheck.WasteBottle);
        } else if (isWasteBottleAvailable === false) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.WASTE_BOTTLE.NOT_DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.IGNORE,
            onClick: this.ignoreElementAvailability,
          };
          loadingButton2 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          const isPoolngRequest = true;
          this.requestDeviceElement(DeviceElementCheck.WasteBottle, isPoolngRequest);
        }
        break;
      }
      // 1
      case DeviceElementCheck.WasteDrainage: {
        const isWasteDrainageAvailable = response.data.WasteDrainageSensor;
        if (isWasteDrainageAvailable === true) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.WASTE_DRAINAGE.DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          loadingButton2 = undefined;
          this.requestCheckOrder(DeviceElementCheck.WasteDrainage);
        } else if (isWasteDrainageAvailable === false) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.WASTE_DRAINAGE.NOT_DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.IGNORE,
            onClick: this.ignoreElementAvailability,
          };
          loadingButton2 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          const isPoolngRequest = true;
          this.requestDeviceElement(DeviceElementCheck.WasteDrainage, isPoolngRequest);
        }
        break;
      }
      // 3
      case DeviceElementCheck.Chip:
      default: {
        const isChipAvailable = response.data.ChipSensor;
        if (isChipAvailable === true) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.CHIP.DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          loadingButton2 = undefined;
          this.requestCheckOrder(DeviceElementCheck.Chip);
        } else if (isChipAvailable === false) {
          loadingText = APPDATA.MESSAGES.DEVICE_ELEMENT_CHECK.CHIP.NOT_DETECTED;
          loadingButton1 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.IGNORE,
            onClick: this.ignoreElementAvailability,
          };
          loadingButton2 = {
            id: passingParam.DeviceCheck,
            label: APPDATA.CANCEL,
            onClick: this.cancelElementAvailability,
          };
          const isPoolngRequest = true;
          this.requestDeviceElement(DeviceElementCheck.Chip, isPoolngRequest);
        }
        break;
      }
    }
    if (passingParam.IsPoolingRequest === false) {
      const deviceElementCheck = {
        showLoading: true,
        loadingText,
        loadingButton1,
        loadingButton2,
      };
      this.updateMessageLoading(deviceElementCheck);
    }
  };

  // ------- common
  generateTubeELementListCheck = () => {
    const checkList = [];
    checkList.push(APPDATA.ENUM.DEVICE_ELEMENT_CHECK.CHIP_SENSOR);
    checkList.push(APPDATA.ENUM.DEVICE_ELEMENT_CHECK.BOTTLE_WASTE_SENSOR);
    checkList.push(APPDATA.ENUM.DEVICE_ELEMENT_CHECK.DRAINAGE_WASTE_SENSOR);
    return checkList;
  };

  ignoreElementAvailability = (e) => {
    const {id} = e.currentTarget;
    let indexElementList;
    switch (id) {
      case DeviceElementCheck.WasteBottle:
        this.requestCheckOrder(DeviceElementCheck.WasteBottle);
        indexElementList = this._deviceElementCheckList.indexOf(APPDATA.ENUM.DEVICE_ELEMENT_CHECK.BOTTLE_WASTE_SENSOR);
        break;
      case DeviceElementCheck.WasteDrainage:
        this.requestCheckOrder(DeviceElementCheck.WasteDrainage);
        indexElementList = this._deviceElementCheckList.indexOf(
          APPDATA.ENUM.DEVICE_ELEMENT_CHECK.DRAINAGE_WASTE_SENSOR,
        );
        break;
      case DeviceElementCheck.Chip:
      default:
        this.requestCheckOrder(DeviceElementCheck.Chip);
        indexElementList = this._deviceElementCheckList.indexOf(APPDATA.ENUM.DEVICE_ELEMENT_CHECK.CHIP_SENSOR);
        break;
    }

    // remove array list content
    if (indexElementList > -1) {
      this._deviceElementCheckList.splice(indexElementList, 1);
    }
  };

  cancelElementAvailability = async () => {
    await postCancelSensorCheck();
    clearTimeout(this._deviceElementAvailabiltyRequest);
    clearTimeout(this._finishAction);
    const deviceElementCheckLoading = {
      showLoading: false,
    };
    this.updateMessageLoading(deviceElementCheckLoading);
  };

  updateMessageLoading = (props) => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: props.showLoading,
        loadingText: props.loadingText,
        loadingButton1:
          props.loadingButton1 !== undefined
            ? {
                label: props.loadingButton1.label,
                onClick: props.loadingButton1.onClick,
                id: props.loadingButton1.id,
              }
            : undefined,
        loadingButton2:
          props.loadingButton2 !== undefined
            ? {
                label: props.loadingButton2.label,
                onClick: props.loadingButton2.onClick,
                id: props.loadingButton2.id,
              }
            : undefined,
      }),
    );
  };

  // curent element is element checked now
  requestCheckOrder = (currentElement) => {
    let nextElement;

    switch (currentElement) {
      case undefined:
        nextElement = DeviceElementCheck.WasteDrainage;
        break;
      case DeviceElementCheck.WasteDrainage:
        nextElement = DeviceElementCheck.WasteBottle;
        break;
      case DeviceElementCheck.WasteBottle:
        nextElement = DeviceElementCheck.Chip;
        break;
      case DeviceElementCheck.Chip:
      default:
        this._finishAction = setTimeout(() => {
          this.actionEndOfDeviceElementAvailability();
        }, 1500);

        break;
    }
    if (nextElement !== undefined) {
      const isPoolingRequest = false;
      this.requestDeviceElement(nextElement, isPoolingRequest);
    }
  };

  actionEndOfDeviceElementAvailability = () => {
    clearInterval(this._deviceElementAvailabiltyRequest);
    this.props.callbackDeviceElementAvailability(this._deviceElementCheckList);
  };

  // ------- end common
  render() {
    return null;
  }
}
export default DeviceElementAvailability;

export const DeviceElementAvailabilityEvent = {
  ELEMENT_AVAILABILITY: 'DeviceElementAvailabilityCheck',
};
const DeviceElementCheck = {
  WasteDrainage: 'WasteDrainage',
  WasteBottle: 'Bottle',
  Chip: 'Chip',
};
